export default __webpack_public_path__ + "static/media/comments.7f311311.svg";